import { CirclePlus, Search } from 'lucide-react'
import React from 'react'
import { Button } from '../../../../../components/ui/button'
import { Input } from '../../../../../components/ui/input'
import { Spinner } from '../../../../../components/ui/spinner'
import { useAddManagerController } from './useAddManagerController'
import { BasicAvatar } from '../../../../../components/BasicAvatar'
import {
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/view/components/ui/dialog'

export const AddManager = () => {
  const {
    data,
    handleSearchInputChange,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    ref,
    searchValue,
    isPending,
    handleUpdateManager,
  } = useAddManagerController()

  return (
    <DialogContent className="p-0">
      <DialogHeader className="px-5 pt-5">
        <DialogTitle>Selecione um gerente</DialogTitle>
      </DialogHeader>
      <DialogClose></DialogClose>
      <div className="border-b-[1px] border-white02" />
      <div className="mx-3">
        <div className="relative my-4 flex items-center px-2">
          <Search size={20} className="z-2 absolute left-5 top-3" />
          <Input
            className="rounded-3xl pl-10"
            placeholder="Pesquisar"
            onChange={handleSearchInputChange}
            value={searchValue}
          />
        </div>
        <div className="container-bar h-80 overflow-y-auto pl-2">
          {data &&
            data.pages.map((page, index) => (
              <React.Fragment key={index}>
                {page.users.map((user) => (
                  <div
                    key={user._id}
                    className="flex items-center justify-between"
                  >
                    <div className="my-4 flex items-center gap-3">
                      <BasicAvatar
                        name={user.name}
                        profileImageUrl={user.profileImageUrl}
                      />
                      <p className="text-sm font-semibold">{user.name}</p>
                    </div>
                    <DialogClose
                      type="submit"
                      disabled={isPending}
                      onClick={() => handleUpdateManager(user)}
                      className="border-none bg-transparent"
                    >
                      <CirclePlus className="cursor-pointer" />
                    </DialogClose>
                  </div>
                ))}
              </React.Fragment>
            ))}
          <div className="mt-2 flex items-center justify-center" ref={ref}>
            <Button
              variant="ghost"
              disabled={!hasNextPage || isFetchingNextPage}
            >
              {isFetchingNextPage ? (
                <Spinner />
              ) : hasNextPage ? (
                <Spinner />
              ) : null}
            </Button>
          </div>
          <div>
            {isFetching && !isFetchingNextPage ? (
              <div className="flex items-center justify-center">
                <Spinner />
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div className="mb-3 border-b-[1px] border-white02" />
    </DialogContent>
  )
}
